import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://blossomcleaningservices.com/#organization",
    "name": "Blossom Cleaning Services",
    "image": "https://blossomcleaningservices.com/images/logo.jpeg",
    "logo": "https://blossomcleaningservices.com/images/logo.jpeg",
    "url": "https://blossomcleaningservices.com",
    "telephone": ["+256752058190", "+256200940830"],
    "email": "contact@blossomcitycleaningservices.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Kololo, opposite Libya Embassy",
      "addressLocality": "Kampala",
      "addressRegion": "Central Region",
      "addressCountry": "UG"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 0.3476,
      "longitude": 32.5825
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "09:00",
        "closes": "15:00"
      }
    ],
    "priceRange": "UGX 50,000 - 5,000,000",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127",
      "bestRating": "5",
      "worstRating": "1"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 0.3476,
        "longitude": 32.5825
      },
      "geoRadius": "50000"
    },
    "sameAs": [
      "https://www.facebook.com/blossomcleaningservices",
      "https://www.instagram.com/blossomcleaningservices"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Cleaning Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Post Construction Cleaning",
            "description": "Professional post-construction cleaning services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Deep Cleaning",
            "description": "Intensive deep cleaning for homes and offices"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Fumigation Services",
            "description": "Professional pest control and fumigation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Maid Services",
            "description": "Vetted and trained domestic staff"
          }
        }
      ]
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Blossom Cleaning Services",
    "url": "https://blossomcleaningservices.com",
    "logo": "https://blossomcleaningservices.com/images/logo.jpeg",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+256752058190",
      "contactType": "customer service",
      "areaServed": "UG",
      "availableLanguage": ["English"]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
